export default __webpack_public_path__ + "static/logo-alt-2f7d612040187728a86b783aadb52ad8.svg";